import { Box, Divider, Link, SvgIcon, Typography } from "@mui/material";
import TelegramIcon from "@mui/icons-material/Telegram";
import { ReactComponent as VkIcon } from "../../images/vkontakte.svg";
import { ReactComponent as OkIcon } from "../../images/odnoklassniki-circle.svg";

export default function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                width: "100%",
                mt: "auto",
                pt: 4,
                pb: 4,
                px: 2,
            }}
        >
            <Divider sx={{ mb: 3, borderColor: "divider" }} />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 3,
                    maxWidth: 1200,
                    mx: "auto",
                }}
            >
                <Box sx={{ minWidth: 180 }}>
                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            mt: 1,
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Link
                            href="https://t.me/+_4o6pFQGrGxiZDdi"
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Питомник Миф и реальность Татьяна и Александр Шамовневы г.Краснодар"
                            color="text.secondary"
                            sx={{ "&:hover": { color: "secondary.main" } }}
                        >
                            <TelegramIcon fontSize="large" />
                        </Link>
                        <Link
                            href="https://vk.com/club215993925"
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Питомник Миф и реальность Татьяна и Александр Шамовневы г.Краснодар"
                            color="text.secondary"
                            sx={{ "&:hover": { color: "secondary.main" } }}
                        >
                            <SvgIcon component={VkIcon} fontSize="large" />
                        </Link>
                        <Link
                            href="https://ok.ru/profile/576292956359"
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Питомник Миф и реальность Татьяна и Александр Шамовневы г.Краснодар"
                            color="text.secondary"
                            sx={{ "&:hover": { color: "secondary.main" } }}
                        >
                            <SvgIcon
                                component={OkIcon}
                                fontSize="large"
                                sx={{
                                    width: "1em",
                                    height: "1em",
                                    color: "#ffae00",
                                    verticalAlign: "middle",
                                }}
                            />
                        </Link>
                    </Box>
                </Box>

                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: { xs: "center", md: "flex-end" },
                        minWidth: 0,
                        ml: "auto",
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        ИНН: 233005569827
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        ОГРНИП: 319237500348382
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Краснодарский край, п. Южный, ул. Крайняя
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        © {new Date().getFullYear()} Питомник Миф и реальность
                    </Typography>
                </Box>
                <Box sx={{ mt: 2, maxWidth: 800, px: 2 }}>
                    <Typography
                        variant="caption"
                        component="p"
                        sx={{
                            color: "text.secondary",
                            textAlign: "center",
                            lineHeight: 1.4,
                        }}
                    >
                        Содержание и наблюдение за каракалами осуществляется Индивидуальным предпринимателем Шамовневой Т.М.
                        в соответствии с требованиями Федерального закона №498-ФЗ «Об ответственном обращении с животными».
                        Информация на сайте носит исключительно ознакомительный характер и не является публичной офертой.
                    </Typography>
                </Box>

                <Box sx={{ display: "none" }}>
                    <a
                        href="https://metrika.yandex.ru/stat/?id=23013811&amp;from=informer"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src="https://informer.yandex.ru/informer/23013811/3_1_FFFFFFFF_EFEFEFFF_0_pageviews"
                            style={{ width: "88px", height: "31px", border: "0" }}
                            alt="Яндекс.Метрика"
                            title="Яндекс.Метрика: данные за сегодня (просмотры, визиты и уникальные посетители)"
                            className="ym-advanced-informer"
                            data-cid="23013811"
                            data-lang="ru"
                        />
                    </a>
                </Box>
            </Box>
        </Box>
    );
}
